import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press16',
  templateUrl: './notice-press16.component.html',
  styleUrls: ['./notice-press16.component.scss']
})
export class NoticePress16Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
